import React, { useEffect, useState } from 'react';
export function NotificationBar() {
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 55);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  return <div className="sticky top-0 z-50 bg-burgundy text-white py-2 px-4 text-center text-sm" data-id="element-193">
      <p className="max-w-6xl mx-auto" data-id="element-194">
        🔥 <span className="font-semibold" data-id="element-195">OFFRE RENAISSANCE :</span> L'Ebook +
        4 Bonus pour 14.97$ (Valeur réelle : 235$). Plus que{' '}
        <span className="font-bold" data-id="element-196">[{formattedTime}]</span> pour rejoindre les{' '}
        <span className="font-bold" data-id="element-197">847 femmes</span> transformées ce mois-ci.
      </p>
    </div>;
}